import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PasswordChangeModal from './_PasswordChangeModal/PasswordChangeModal';
import EditEmailModal from './EditEmailModal/EditEmailModal';
import { useApp } from '../../providers/AppProvider';
import { Typography, Grid, Box, TextButton, TextField, styled } from 'bonfire-kindling';

const StyledGridButtonContainer = styled(Grid)(() => ({ display: 'flex', alignItems: 'flex-end' }));
const StyledEditButton = styled(TextButton)(({ theme }) => ({
  fontWeight: 600,
  cursor: 'pointer',
  textDecoration: 'underline',
  color: theme.palette.primary.main,
}));

const AccountDetails = () => {
  const { t } = useTranslation();
  const { email } = useApp();

  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);

  const [isEmailModalOpen, openEmailModal] = useState(false);

  const closePasswordModal = React.useCallback(
    () => setIsPasswordModalOpen(false),
    [setIsPasswordModalOpen]
  );

  const closeEmailModal = React.useCallback(() => openEmailModal(false), [openEmailModal]);

  return (
    <>
      <Typography variant="h1" component="h2">
        {t('settings.account.title')}
      </Typography>
      <Grid container sx={{ marginTop: '1rem' }}>
        <Grid item xs={8}>
          <TextField
            label={t('settings.account.email')}
            name="email"
            disabled
            value={email}
            fullWidth
          />
        </Grid>
        <StyledGridButtonContainer item xs={1}>
          <Box ml={1}>
            <StyledEditButton
              component="button"
              variant="text"
              onClick={() => openEmailModal(true)}
              data-cy="emailEdit"
              label={t('settings.account.edit')}
            />
          </Box>
        </StyledGridButtonContainer>
      </Grid>
      <Grid container sx={{ marginTop: '1rem' }}>
        <Grid item xs={8}>
          <TextField
            label={t('settings.account.password')}
            name="password"
            disabled
            value="********"
            fullWidth
          />
        </Grid>
        <StyledGridButtonContainer item xs={1}>
          <Box ml={1}>
            <StyledEditButton
              component="button"
              variant="text"
              onClick={() => setIsPasswordModalOpen(true)}
              data-cy="passwordEdit"
              label={t('settings.account.edit')}
            />
          </Box>
        </StyledGridButtonContainer>
      </Grid>
      <PasswordChangeModal onClose={closePasswordModal} open={isPasswordModalOpen} />
      <EditEmailModal onClose={closeEmailModal} open={isEmailModalOpen} currentEmail={email} />
    </>
  );
};

export default AccountDetails;
